export type Point = {
  readonly x: number
  readonly y: number
}
